import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import L from 'leaflet';
import $ from 'jquery';

const RouteViewerOsmControl = ({
    route,
    user,
    state,
    onShowPoint,
    onHidePoint,
    onZoomChanged,
    onCenterChanged,
    visiblePoint,
    ...props
}) => {

    const mapRef = useRef(null);
    const zoomInRef = useRef(null);
    const zoomOutRef = useRef(null);
    const distanceUnit = user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km';
    const elevationUnit = user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm';

    var map; 

    
    useEffect(() => {
        setUpMap();
        if (map) {
            if (route.points) {
                loadRoute();
            }
        }

    }, []);

    useEffect(() => {
        if (visiblePoint) {
            if (visiblePoint.state === "show") {
                visiblePoint.marker.setIcon(pointIcon);
                return
            }
            visiblePoint.marker.setIcon(pointIconHidden);
        }
    }, [visiblePoint])


    function setUpMap() {
        if (state.center) {

            map = L.map('osm-map', {
                center: state.center,
                zoom: state.zoom,
                zoomControl: false
            });

            var layer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: '&amp;copy <a href="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png">OpenStreetMap</a> contributors'
            }).addTo(map);

            layer.on("load", handleLayerLoad)
            map.on('moveend', handleMapMove)
        }
    }

    function handleLayerLoad() {
        var zoomIn = zoomInRef.current;
        $(zoomIn).unbind('click');
        $(zoomIn).click((e) => {
            e.preventDefault()
            let zoom = map.getZoom();
            zoom = zoom + 1
            map.setZoom(zoom);
            onZoomChanged(zoom);
            return false;
        })

        var zoomOut = zoomOutRef.current;
        $(zoomOut).unbind('click');
        $(zoomOut).click((e) => {
            e.preventDefault()
            let zoom = map.getZoom();
            zoom = zoom - 1
            map.setZoom(zoom);
            onZoomChanged(zoom);
            return false;
        })
    }

    function handleMapMove() {
        var mapCentre = map.getCenter();
        onCenterChanged(mapCentre);
        var mapZoom = map.getZoom();
        onZoomChanged(mapZoom);
    }

    function loadRoute() {

        if (state.center.lat === 0 & state.center.lng === 0) {
            var bounds = getMapBounds();
            if (bounds[0][0] === 0 && bounds[0][1] === 0) {
                onZoomChanged(12);
                onCenterChanged(route.startPoint);
            } else {
                map.fitBounds(bounds, { animate: false });
                onCenterChanged(map._lastCenter);
                onZoomChanged(map._zoom);
            }
        }

        if (route.routeId) {
            var start = L.icon({
                iconUrl: '/resources/images/start-marker.png',
                iconSize: [29, 50],
                iconAnchor: [15, 47]
            })
            var marker3 = L.marker([route.startPoint.latitude, route.startPoint.longitude], { icon: start }).addTo(map);

            var path = []
            route.points.map((point, id) => {

                var latlng = new L.latLng(point.latitude, point.longitude);
                latlng.distanceAtPoint = point.distanceAtPoint;
                path.push(latlng);
                var marker = L.marker(latlng, { icon: pointIconHidden }).addTo(map);
                marker.on('mouseover', showPointDetails);
                marker.on('mouseout', hidePointDetails);
                var popup = L.popup({ closeButton: false, className: "osm-infobox" })
                popup.setContent(`Distance: <strong>${point.distanceAtPoint.toFixed(2)}</strong> ${distanceUnit}<br/>Elevation: <strong>${point.elevationAtPoint.toFixed(0)}</strong> ${elevationUnit}`);
                marker.bindPopup(popup);
                point.distanceMarker = marker;

            });

            var polyline = L.polyline(path, { color: '#14a4ff' });
            polyline.addTo(map);
        }
    }

    const pointIcon = L.icon({
        iconUrl: '/resources/images/routespot.png',
        iconSize: [8, 8],
        iconAnchor: [4, 4]
    })

    const pointIconHidden = L.icon({
        iconUrl: '/resources/images/routespot_blank.png',
        iconSize: [8, 8],
        iconAnchor: [4, 4]
    })

    function showPointDetails(e) {
        e.target.setIcon(pointIcon);
        e.target.openPopup();
        onShowPoint(e.latlng)
    }

    function hidePointDetails(e) {
        e.target.setIcon(pointIconHidden);
        e.target.closePopup();
        onHidePoint(); 
    }


    function getMapBounds() {
        if (!route.routeId) {
            return new props.google.maps.LatLngBounds();
        }
        var sw = [route.routeBoundary.minimumLatitude, route.routeBoundary.minimumLongitude];
        var ne = [route.routeBoundary.maximumLatitude, route.routeBoundary.maximumLongitude];
        var bounds = [sw, ne];
        return bounds;
    }

    return (
        <div className="osm-container">
            <div className="zoom-controls btn-group" role="group">
                <button ref={zoomInRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-plus" /></button>
                <button ref={zoomOutRef} className="btn btn-secondary btn-sm" ><span className="fas fa-search-minus" /></button>
            </div>
            <div id="osm-map"></div>
        </div>
    );
}

RouteViewerOsmControl.propTypes = {
    route: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    onShowPoint: PropTypes.func, 
    onHidePoint: PropTypes.func,
    onZoomChanged: PropTypes.func,
    onCenterChanged: PropTypes.func,
    visiblePoint: PropTypes.object
}

export default RouteViewerOsmControl;


// WEBPACK FOOTER //
// ./src/components/routes/RouteViewerOsmControl.js